(function () {
  'use strict';

  angular
    .module('directives.attachmentImg', [])
    .directive('attachmentImg', directive);

  directive.$inject = ['$cacheFactory', 'attachmentService'];

  function directive($cacheFactory, attachmentService) {
    const storage = $cacheFactory('attachment-base64');

    return {
      link: async function postLink(scope, element, attrs) {
        const attachmentId = attrs?.attachmentId;

        if (!attachmentId) {
          return;
        }

        // Check if base64 has already been loaded for this attachment
        let base64 = storage.get(attachmentId);

        // Attachment not in cache, download it
        if (!base64) {
          try {
            const blob = await attachmentService.downloadBlob(attachmentId);

            if (!blob) {
              return;
            }

            base64 = await attachmentService.getBase64FromBlob(blob);

            if (!base64) {
              return;
            }
          } catch {
            return;
          }

          storage.put(attachmentId, base64);
        }

        element.attr('src', 'data:image/png;base64,' + base64);
      }
    };
  }
})();
